import store from "../../../../../app/store";

const handleSubmitPlan = async (
  event,
  plan,
  userId,
  email,
  month,
  currency
) => {
  if (event) event.preventDefault();
  // Ensure PaymentElement is available
  const domain = process.env.REACT_APP_SERVER;
  const url = `${domain}/razorpay/payment`;
  const token = store.getState().auth.token;

  if (!token) {
    return {
      data: null,
      error: true,
      msg: "Authentication failed. No token found.",
    };
  }

  if (plan?.toLowerCase() === "free"?.toLowerCase()) {
    localStorage.removeItem("userSelectedPlan");
    localStorage.removeItem("renderCountPlan");
    return;
  }

  const option = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      plan: plan,
      currency: currency,
      month: parseInt(month),
    }),
  };

  const response = await fetch(url, option);

  const data = await response.json();

  const options = {
    key: process.env.REACT_APP_razorpay_public_key,
    amount: data.amount,
    name: "Jaano.Ai",
    currency: data.currency,
    description: plan.name,
    order_id: data.id,
    callback_url: `${domain}/razorpay/payment/varification/${userId}/${plan}?month=${month}`,
    prefill: {
      email: email,
    },
    month: parseInt(month),
  };

  const razorpay = new window.Razorpay(options);
  razorpay.open();
  localStorage.removeItem("userSelectedPlan");
  localStorage.removeItem("renderCountPlan");
  localStorage.removeItem("mon");
};

export default handleSubmitPlan;
